// extracted by mini-css-extract-plugin
export default {"layout":"EnergyLabel_layout__DGlIn","siderDemo":"EnergyLabel_siderDemo__tMzRS","content":"EnergyLabel_content__UtOSz","empty":"EnergyLabel_empty__pvFAg"};